import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";

export const getGradeList = createAction(
  "[Grades] Get All Grades Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadGradeList = createAction(
  "[Grades] Load All Grades List Action",
  props<{ response: any[] }>()
);
export const getGradesList = createAction(
  "[Grades] Get All Grades List Action",
  props<{ options: any }>()
);
export const loadGradesList = createAction(
  "[Grades] Load All Grades List Action",
  props<{ response: any[] }>()
);
export const getExcelGradesList = createAction(
  "[Grades] Get All Grades Excel List Action",
  props<{ options: any }>()
);
export const loadExcelGradesList = createAction(
  "[Grades] Load All Grades Excel List Action",
  props<{ response: any[] }>()
);
export const resetGradesState = createAction(
  "[Grades] Reset Grades State Action"
);
export const updateGrade = createAction(
  "[Grades] Update Grade Action",
  props<{ grade: any }>()
);
export const createGrade = createAction(
  "[Grades] Create Grade Action",
  props<{ grade: any }>()
);
export const getGrade = createAction(
  "[Grades] Get Grade Action",
  props<{ code: string }>()
);
export const loadGrade = createAction(
  "[Grades] Load Grade Action",
  props<{ response: any }>()
);
export const getGradesTableConfig = createAction(
  "[Grades] Get Grades Table Configuration Action",
  props<{ options: any }>()
);
export const loadGradesTableConfig = createAction(
  "[Grades] Load Grades Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveGradesTableConfig = createAction(
  "[Grades] Save Grades Table Configuration Action",
  props<{ config: any }>()
);
export const gradeLoadEnd = createAction("[Grades] Load Grade End Action");
export const resetGrade = createAction("[Grades] Reset Grade Action");
export const resetCreation = createAction("[Grades] Reset Creation Action");
